export const blockIconsNotificationEventNote = (
	<span className='material-symbols-outlined'>event_note</span>
);
